<div
  class="themes-wrapper h-screen bg-background scrollbar-thumb-rounded scrollbar-track-rounded grow overflow-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-muted">
  <div class="grid lg:grid-cols-2">
    <aside class="z-sticked m-2 w-95 md:w-130 lg:w-155 h-[98vh]">
      <div
        class="relative flex h-full w-full flex-col justify-between rounded-xl"
        data-testid="left-sidebar">
        <img
          src="assets/images/auth.png"
          alt="B2B CRM Authentication"
          loading="eager"
          fetchpriority="high"
          decoding="async"
          crossorigin="anonymous"
          class="h-full w-full rounded-xl object-cover" />
        <div
          class="absolute bottom-0 left-0 right-0 top-0 flex flex-col justify-between p-6 text-white">
          <div class="flex gap-2 items-center">
            <div
              class="w-8 h-8 rounded-lg border-2 border-white flex items-center justify-center shadow-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="h-4 w-4 icon icon-tabler icons-tabler-filled icon-tabler-location">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M20.891 2.006l.106 -.006l.13 .008l.09 .016l.123 .035l.107 .046l.1 .057l.09 .067l.082 .075l.052 .059l.082 .116l.052 .096c.047 .1 .077 .206 .09 .316l.005 .106c0 .075 -.008 .149 -.024 .22l-.035 .123l-6.532 18.077a1.55 1.55 0 0 1 -1.409 .903a1.547 1.547 0 0 1 -1.329 -.747l-.065 -.127l-3.352 -6.702l-6.67 -3.336a1.55 1.55 0 0 1 -.898 -1.259l-.006 -.149c0 -.56 .301 -1.072 .841 -1.37l.14 -.07l18.017 -6.506l.106 -.03l.108 -.018z" />
              </svg>
            </div>
            <span
              class="text-xl font-semibold bg-white bg-clip-text text-transparent"
              >B2B CRM</span
            >
          </div>
          <div class="lg:w-10/12">
            <div class="mt-4 flex text-14 text-base-500">
              <div
                class="cursor-pointer text-primary-600 hover:text-primary-700 active:text-primary-800 inline-flex items-center transition-colors">
                <a href="/terms" target="_blank" class="body-m-medium"
                  ><span class="text-primary"> Terms &amp; Conditions </span></a
                >
              </div>
              ,
              <div
                class="cursor-pointer text-primary-600 hover:text-primary-700 active:text-primary-800 inline-flex items-center transition-colors ml-1">
                <a href="/privacy" target="_blank" class="body-m-medium"
                  ><span class="text-primary"> Privacy policy </span></a
                >
              </div>
              ,
              <div
                class="cursor-pointer text-primary-600 hover:text-primary-700 active:text-primary-800 inline-flex items-center transition-colors ml-1">
                <a href="/cookie-policy" target="_blank" class="body-m-medium"
                  ><span class="text-primary"> Cookie policy </span></a
                >
              </div>
            </div>
            <span class="mt-1 text-14 leading-4.5">
              © 2025 B2B CRM. All rights reserved
            </span>
          </div>
        </div>
      </div>
    </aside>
    <div class="flex flex-col gap-4 p-6 md:p-10">
      <div class="flex flex-1 items-center justify-center">
        <div class="w-full max-w-xs">
          <router-outlet />
        </div>
      </div>
    </div>
  </div>
</div>
